import axios from 'axios'
// 确保你已经导入Vue Router
import router from '@/router' 
// 假设你的Vue Router实例导出在这个位置
import store from "@/store"
import { getToken, removeToken } from '@/utils/auth'
import { Message, MessageBox } from 'element-ui'

// 创建 Axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL + '/haloapi', // api 的基础url前缀
    timeout: 25000, // 请求超时时间
    headers: {
        'Content-Type': "application/json; charset=utf-8"//我们返回的是一个json数据
    },
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，比如添加 Token
        // console.log("interceptors.request 拦截器", store.getters.getToken)
        if (store.getters.token) {
                config.headers['halo-token'] = getToken()
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        console.log(error, "interceptors.error 请求拦截器出错")
        Promise.reject(error)
    }
)

function handleAuthError(code, msg) {
    // 处理身份验证相关的错误
    Message.info(msg || '身份验证错误，请重新登录！')
    removeToken()

    // 可根据错误类型跳转不同页面
    if ([10001, 10002, 10003, 10004, 10005, 10006, 10007].includes(code)) {
        router.push('/login')
    }
}

function showMessage(type = 'error', msg = '发生了一些错误，请重试！') {
    Message[type](msg)
}


// 响应拦截器
service.interceptors.response.use(
    response => {
        const { code, data, msg } = response.data

        switch (code) {
            case 200:
                return { code, data, msg }

            case 201:
                return removeToken()

            case 301:
                showMessage('error', msg || '登录失效，请重新登录')
                router.push('/login')
                return Promise.reject(new Error(msg || '未登录'))

            case 10001:
            case 10002:
            case 10003:
            case 10004:
            case 10005:
            case 10006:
            case 10007:
                handleAuthError(code, msg)
                return Promise.reject(new Error(msg || '认证失败'))

            default:
                showMessage('error', msg)
                return Promise.reject(new Error(msg || '未知错误'))
        }
    },
    error => {
        if (error.response && error.response.data) {
            const msg = error.response.data.msg
            showMessage('error', msg || '请求失败')
        } else {
            showMessage('error', '网络错误，请检查您的网络连接')
        }
        return Promise.reject(error)
    }
)


export default service;